import React from 'react';
import { Col, Container, Row } from "react-bootstrap";

// Estilo reaproveitado do banner de busca de carros (mesma classe, mesmo visual)
import '../../Busca/Banner/Banner.scss';
import 'react-tooltip/dist/react-tooltip.css'

function MotosBanner() {

    return (
        <>
            <section className='buscaBanner'>
                <Container>
                    <Row className='justify-content-md-center'>
                        <Col xs={12} sm={12} md={12} lg={8} className='boxBuscaBanner'>
                            <div className='textBuscaBanner'>
                                <h3>QUALIDADE E PÓS-VENDA</h3>
                                <h2>INCOMPARÁVEIS</h2>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default MotosBanner;
